import avatar from '../../assets/images/tutor.png';
import Button from '../Button/Button';
import CamOff from '../../assets/icons/CamOff';
import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { getPaidCourse } from '../../services/paymentService';
import Spinner from '../Spinner/Spinner';

const LiveClassDropdown = () => {
  const navigate = useNavigate();
  let notification = JSON.parse(localStorage.getItem('notification'));
  const [paidCourses, setPaidCourses] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let { id } = JSON.parse(localStorage.getItem('userData'));
    let token = localStorage.getItem('token');

    const getPaidCourses = async () => {
      setLoading(true);
      let course = await getPaidCourse(id, token);
      setPaidCourses(course.data.courses);
      setLoading(false);
    };
    getPaidCourses();
  }, []);

  const weekdays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  const d = new Date();
  let day = weekdays[d.getDay()];
  let hour = d.getHours();

  return (
    <div className='dropdown'>
      <div className='dropdown__live-heading'>
        <b>Live class</b>
        <Link to='/profile?classes=live'>View All</Link>
      </div>

      {loading ? (
        <Spinner />
      ) : paidCourses.length > 0 ? (
        <div className='dropdown__content'>
          {/* <div className="dropdown__content__image">
            <img src={notification?.image || avatar} alt="" />
          </div> */}
          {paidCourses.map((item) =>
            item.live_classes?.map((el) => (
              <div className='dropdown__content__item'>
                <p className='dropdown__content__item__top'>
                  {el.learning_focus} class with {item?.school?.name}
                </p>
                {el.schedules.map((item) => (
                  <div style={{ marginBottom: '10px' }}>
                    <div className='dropdown__content__item__period'>
                      <p>{item?.day}</p>
                      <svg
                        width='6'
                        height='6'
                        viewBox='0 0 6 6'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <circle cx='3' cy='3' r='3' fill='#5A5955' />
                      </svg>
                      <p>{`${new Date(
                        '1970-01-01T' + item?.start_time + 'Z'
                      ).toLocaleTimeString('en-US', {
                        timeZone: 'UTC',
                        hour12: true,
                        hour: 'numeric',
                        minute: 'numeric',
                      })} - ${new Date(
                        '1970-01-01T' + item?.end_time + 'Z'
                      ).toLocaleTimeString('en-US', {
                        timeZone: 'UTC',
                        hour12: true,
                        hour: 'numeric',
                        minute: 'numeric',
                      })}  `}</p>
                    </div>
                    <Button
                      className='primary-btn'
                      text='Join Class'
                      onClick={() => {
                        window.open(el.meeting_url, '_blank');
                      }}
                      disabled={
                        day.toLowerCase() !== item?.day?.toLowerCase() ||
                        hour < Number(item?.start_time?.split(':')[0])
                      }
                    />
                  </div>
                ))}
              </div>
            ))
          )}

          <div>
            <svg
              width='8'
              height='8'
              viewBox='0 0 8 8'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <circle cx='4' cy='4' r='4' fill='#7CD1B8' />
            </svg>
          </div>
        </div>
      ) : (
        <div className='dropdown__empty'>
          <CamOff />
          <p>No upcoming live class</p>
        </div>
      )}
    </div>
  );
};

export default LiveClassDropdown;
